export default {"src":"/_next/static/media/phone_icon.07da71ec.svg","height":20,"width":24,"blurWidth":0,"blurHeight":0};